import { action, makeObservable, observable } from 'mobx';
import { userInfoStore, roundInfoStore, notificationStore } from '@pascal/pascal-core';
import {
  applicationStore,
  freeBetStore,
  gameConfigStore,
} from '@pascal/pascal-core/shared/core/store';

import { gameLiveConnection } from '../services';
import { checkValidRange } from '../helpers/supporters';
import { marketTypes, rangeDefaultValue } from '../helpers/constants';
import { gameStore } from './gameStore';

class DoBetStore {
  winAmount = 0;

  marketType = marketTypes.Under;

  rangeNumber = rangeDefaultValue;

  isLoadingBetButton = false;

  currentOdd = null;

  totalBetsAmount = 0;

  betData = {
    betId: null,
    amount: gameConfigStore.limits.minBet || 0,
    isBetAccepted: false,
    winAmount: null,
    isDisabled: false,
    freeBetId: null,
  };

  constructor() {
    makeObservable(this, {
      currentOdd: observable,
      winAmount: observable,
      isLoadingBetButton: observable,
      betData: observable.deep,
      totalBetsAmount: observable,
      marketType: observable,
      rangeNumber: observable,
      setWinAmount: action.bound,
      setRangeNumber: action.bound,
      doBetSender: action.bound,
      setBetAmount: action.bound,
      setMarketType: action.bound,
      decreaseDemoBalance: action.bound,
      increaseDemoBalance: action.bound,
      resetGameStates: action.bound,
      resetRangeState: action.bound,
      handleDoBetResult: action.bound,
      handleClearRoundFin: action.bound,
      setIsLoadingBetButton: action.bound,
      updateIsDisabledBetSection: action.bound,
      updateBetAccepted: action.bound,
      updateInitialBetData: action.bound,
      updateTotalBetsAmount: action.bound,
      setCurrentOdd: action.bound,
    });
  }

  setCurrentOdd(currentWinOdd) {
    this.currentOdd = currentWinOdd;
  }

  updateTotalBetsAmount(amount, isReset = false) {
    if (isReset) {
      this.totalBetsAmount = 0;
    } else {
      this.totalBetsAmount += Number(amount);
    }
  }

  updateBetAccepted(isBetAccepted, betId) {
    this.betData = {
      ...this.betData,
      isBetAccepted,
      betId,
    };
  }

  setIsLoadingBetButton(isLoadingBetButton) {
    this.isLoadingBetButton = isLoadingBetButton;
  }

  setBetAmount(amount) {
    this.betData = { ...this.betData, amount };
  }

  updateIsDisabledBetSection(isDisabledBetSection) {
    this.betData = {
      ...this.betData,
      isDisabled: isDisabledBetSection,
    };
  }

  setMarketType(type) {
    this.marketType = type;
    this.setRangeNumber();
  }

  setRangeNumber(number = this.rangeNumber) {
    this.rangeNumber = checkValidRange(!this.marketType, number, gameStore.margin);
  }

  resetRangeState() {
    this.setRangeNumber(rangeDefaultValue);
    this.setMarketType(marketTypes.Under);
  }

  setWinAmount(winAmount) {
    this.winAmount = winAmount;
    if (winAmount) {
      setTimeout(() => gameLiveConnection.getBalance(), 900);
    }
  }

  setBetAccepted() {}

  increaseDemoBalance(amount, odd) {
    const balance = userInfoStore.balance + amount * odd;
    userInfoStore.setDemoBalance(balance);
  }

  decreaseDemoBalance(betAmount) {
    userInfoStore.setDemoBalance(userInfoStore.balance - betAmount);
  }

  resetGameStates() {
    this.betData = {
      betId: null,
      range: [0, 99],
      amount: gameConfigStore.limits.defaultBetAmount || gameConfigStore.limits.minBet || 0,
      isBetAccepted: false,
      winAmount: null,
      finishedOdd: null,
      isDisabled: false,
    };
    this.isLoadingBetButton = false;
    this.setWinAmount('');
    this.updateTotalBetsAmount(0, true);
    notificationStore.setNotificationType(null);
  }

  handleClearRoundFin() {
    this.betData = {
      ...this.betData,
      betId: null,
      isBetAccepted: false,
      isDisabled: false,
    };
  }

  setDemoBetData() {}

  updateInitialBetData(data) {
    this.betData = data;
  }

  doBetSender() {
    const { amount } = this.betData;
    const { roundId } = roundInfoStore;
    const { isDemo } = applicationStore;
    const { activeFreeBet } = freeBetStore;

    this.setIsLoadingBetButton(true);

    const doBetModel = {
      amount,
      roundId: roundId,
      freeBetId: activeFreeBet?.id && !isDemo ? activeFreeBet?.id : null,
      betData: {
        marketType: this.marketType,
        number: this.rangeNumber,
      },
    };

    gameLiveConnection.doBet(doBetModel);
  }

  handleDoBetResult(doBetData) {
    const { responseCode } = doBetData;
    this.setIsLoadingBetButton(false);
    notificationStore.setNotificationType({ responseCode });
  }

  setDoBetResult() {}

  sendCashOut() {}

  setPopUpWinData() {}
}

export const doBetStore = new DoBetStore();
